import getDevice from './module/getDevice.js'
import getBaseUrl from './module/getBaseUrl.js'
import functions from './functions.js' // Activamos functions si no usamos Barba.js

const baseUrl = getBaseUrl()
// console.log('URL base detectada:', baseUrl)

/* ///////////////////////////////////////////////////////////////////// */
/* ///////////////////////// SERVICE WORKER //////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// */

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register( baseUrl + '/sw.js')
//     .then(reg => console.log('Registro de SW exitoso', reg))
//     .catch(err => console.warn('Error al tratar de registrar el sw', err))
// }

/* ///////////////////////////////////////////////////////////////////// */
/* /////////////////////////// DEVICE DATA ///////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// */

const deviceData = getDevice()

/* Ejecutar el getDevice si cambia el tamaño del navegador o rota el dispositivo */
window.addEventListener('resize', getDevice)
window.addEventListener('orientationchange', getDevice)

/* ///////////////////////////////////////////////////////////////////// */
/* /////////////////////////////// EXEC //////////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// */

document.addEventListener('DOMContentLoaded', function () {
  functions(deviceData)
})
